import { render, staticRenderFns } from "./sidekiq.vue?vue&type=template&id=2fb2dd25&scoped=true&"
import script from "./sidekiq.vue?vue&type=script&lang=js&"
export * from "./sidekiq.vue?vue&type=script&lang=js&"
import style0 from "./sidekiq.vue?vue&type=style&index=0&id=2fb2dd25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2dd25",
  null
  
)

export default component.exports